// extracted by mini-css-extract-plugin
module.exports = {"ComplaintForm":"ph_a pz_cv pz_je","ComplaintForm__title":"ph_b pz_qt pz_rc","ComplaintForm__form__buttons":"ph_c pz_a pz_u"};